import { render } from "./pay-review.vue?vue&type=template&id=1aa39330&scoped=true"
import script from "./pay-review.vue?vue&type=script&lang=js"
export * from "./pay-review.vue?vue&type=script&lang=js"

import "./pay-review.vue?vue&type=style&index=0&id=1aa39330&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa39330"]])

export default __exports__